$(document).ready(function() {
    const $quantityInput = $('.product-quantity-v2-input');

    $('.product-quantity-v2-plus').off('click').on('click', function() {
        console.log('plus');
        let currentValue = parseInt($quantityInput.val());
        $quantityInput.val(currentValue + 1);
    });

    $('.product-quantity-v2-minus').off('click').on('click', function() {
        console.log('minus');
        let currentValue = parseInt($quantityInput.val());
        if (currentValue > 1) {
            $quantityInput.val(currentValue - 1);
        }
    });
});